import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  //   elementWrapper: {
  //     display: "flex",
  //     justifyContent: "space-between",
  //     flexFlow: "row wrap",
  //     alignItems: "center",
  //   },
  //
  buttonBack: {
    border: "1px solid #121212",
    padding: "0.7em 1.6em",
    margin: "3px",
    //
    boxShadow: "none",
    borderRadius: "8em",
    boxSizing: "borderBox",
    textDecoration: "none",

    //
    color: "#121212",
    backgroundColor: "transparent",

    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    //

    //
    "&:hover": {
      //
      border: "1px solid #121212",
      padding: "0.7em 1.6em",

      boxShadow: "none",
      backgroundColor: "#121212",
      color: "rgb(248,248,248)",

      //
    },
  },

  //
  buttonPay: {
    border: "1px solid #121212",
    padding: "0.7em 1.6em",
    boxShadow: "none",
    borderRadius: "8em",
    boxSizing: "borderBox",
    textDecoration: "none",
    margin: "3px",

    //
    backgroundColor: "#121212",
    color: "rgb(248,248,248)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    //
    minWidth: "150px",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "5px",
    },
    [theme.breakpoints.up("xs")]: {
      marginRight: "20px",
    },

    //
    "&:hover": {
      minWidth: "150px",
      [theme.breakpoints.down("xs")]: {
        marginBottom: "5px",
      },
      [theme.breakpoints.up("xs")]: {
        marginRight: "20px",
      },
      //
      border: "1px solid #121212",
      padding: "0.7em 1.6em",

      boxShadow: "none",

      color: "rgb(248,248,248)",
      backgroundColor: "#000000",
      //
    },
  },
}));
